import { configureStore } from "@reduxjs/toolkit";
import { imageStore } from "./image";
import { mapStore } from "./map";
import { priceMiddleware } from "./priceMiddleware";

const store = configureStore({
  reducer: {
    map: mapStore,
    image: imageStore,
  },
  // RTK includes redux-thunk by default, no need to add it manually
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Allow non-serializable values for Mapbox instances
      serializableCheck: {
        ignoredActions: ['map/initMap'],
        ignoredPaths: ['map.map', 'map.geoSearch'],
      },
    }).concat(priceMiddleware),
});

export default store;
export { store };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
